<template>
  <section class="relative min-h-screen flex items-center justify-center overflow-hidden bg-slate-900 text-white">
    <!-- Background Gradient -->
    <div class="absolute inset-0 z-0">
      <div class="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] rounded-full bg-purple-600/20 blur-[120px]"></div>
      <div class="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] rounded-full bg-blue-600/20 blur-[120px]"></div>
    </div>

    <div class="container mx-auto px-6 relative z-10 text-center">
      <div class="inline-block mb-4 px-3 py-1 rounded-full border border-slate-700 bg-slate-800/50 backdrop-blur-sm">
        <span class="text-sm font-medium text-blue-400">👋 欢迎来到我的个人空间</span>
      </div>
      
      <h1 class="text-5xl md:text-7xl font-bold mb-6 tracking-tight">
        你好，我是 <span class="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-500">xiaoyang</span>
      </h1>
      
      <p class="text-xl md:text-2xl text-slate-300 mb-10 max-w-2xl mx-auto leading-relaxed">
        热衷于探索前沿技术，专注于创造优雅的用户体验。
        <span class="block mt-2 text-slate-400 text-lg">探索 · 创新 · 分享</span>
      </p>
      
      <div class="flex flex-col sm:flex-row gap-4 justify-center items-center">
        <button 
          @click="scrollToProjects"
          class="px-8 py-3 rounded-full bg-blue-600 hover:bg-blue-500 text-white font-medium transition-all transform hover:scale-105 shadow-lg shadow-blue-600/25"
        >
          查看项目
        </button>
        <button 
          @click="scrollToContact"
          class="px-8 py-3 rounded-full bg-slate-800 hover:bg-slate-700 text-white border border-slate-700 font-medium transition-all hover:border-slate-600"
        >
          联系我
        </button>
      </div>

      <!-- Scroll Indicator -->
      <div class="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce text-slate-500">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 14l-7 7m0 0l-7-7m7 7V3" />
        </svg>
      </div>
    </div>
  </section>
</template>

<script setup>
const emit = defineEmits(['scroll-to-projects'])

const scrollToProjects = () => {
  emit('scroll-to-projects')
};


const scrollToContact = () => {
  const contactSection = document.getElementById('contact');
  if (contactSection) {
    contactSection.scrollIntoView({ behavior: 'smooth' });
  }
};
</script>

<style scoped>
/* Any custom additional styles if needed, but Tailwind covers most */
</style>
